import { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router";

import { useGlobalContext } from "app/store/GlobalContext";
import { MessageItem } from "models/inbox/inbox";
import MessageSidebarItem from "views/inbox/components/Inbox/sidebar/messageSidebarItem";
import NoMessagesToShowInfoText from "./noMessagesToShowInfoText/noMessagesToShowInfoText";

import { useRequiredCustomerId } from "hooks/use-customer-id";
import "../index.scss";

type Props = {
  messages: MessageItem[];
};

export default function MessageSidebarList({ messages }: Props) {
  const { handleNavigation } = useGlobalContext();

  const { messageId: currentMessageId } = useParams();

  const [activeMessageId, setActiveMessageId] = useState<string>("");

  const customerId = useRequiredCustomerId();

  useEffect(() => {
    if (currentMessageId) {
      setActiveMessageId(`messages/${currentMessageId}`);
    } else {
      setActiveMessageId("");
    }
  }, [currentMessageId]);

  const sortMessages = useMemo(() => {
    return [...(messages ?? [])].sort(
      (a, b) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [messages]);

  const handleOnSelect = useCallback(
    (messageId: string, e) => {
      handleNavigation({
        url: `/customers/${customerId}/inbox/sent/${messageId}`,
        eventTitle: "Message",
        e: e
      });
    },
    [handleNavigation, customerId]
  );

  if (!messages?.length) {
    return <NoMessagesToShowInfoText />;
  }

  return (
    <>
      {sortMessages.map((msg) => {
        const { messageId } = msg;
        return (
          <MessageSidebarItem
            key={messageId}
            message={msg}
            isActive={activeMessageId === messageId}
            onSelect={(e) => handleOnSelect(messageId, e)}
          />
        );
      })}
    </>
  );
}
